import { Component, OnInit } from '@angular/core';
export class MainToolbarChatComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[hd-main-toolbar-chat]',
  template: `
    <a class="right-menu-item-link">
        <!-- <span class="m-nav__link-badge m-badge m-badge--dot m-badge--dot-small m-badge--danger"></span> -->
        <span class="right-menu-link-icon">
            <i class="flaticon-chat"></i>
        </span>
    </a>
  `,
  styles: [`
    :host {
      padding: 0 12px;
      height: 100%;
      display: inline-block;
      vertical-align: middle;
      position: relative;
      font-size: 14px;
      font-weight: 300;
      font-family: "Poppins";
      -webkit-font-smoothing: antialiased;
      line-height: 1.5;
      color: #212529;
      background-color: #fff; }

    .right-menu-item-link {
      position: relative;
      margin: 0 auto;
      width: auto;
      padding: 9px 0;
      display: table;
      table-layout: fixed;
      height: 100%;
      text-decoration: none;
      outline: none !important;
      vertical-align: middle;
      -ms-touch-action: manipulation;
          touch-action: manipulation;
      color: #5867dd;
      background-color: transparent;
      cursor: auto;
      padding: 0;
      margin: 0;
      list-style: none;
      height: 100%;
      margin: 0px;
      padding: 0px;
      font-size: 14px;
      font-weight: 300;
      font-family: "Poppins";
      cursor: pointer; }
      .right-menu-item-link .right-menu-link-icon {
        text-align: center;
        line-height: 0;
        vertical-align: middle;
        padding: 0;
        color: #ad5beb;
        display: table-cell;
        height: 100%;
        width: 35px;
        font-size: 1.4rem;
        -webkit-animation-fill-mode: initial;
                animation-fill-mode: initial;
        text-decoration: none;
        background-color: transparent;
        height: 100%;
        margin: 0px;
        padding: 0px;
        font-weight: 300;
        font-family: "Poppins";
        -ms-text-size-adjust: 100%;
        -webkit-font-smoothing: antialiased; }
      .right-menu-item-link i {
        font-size: 1.5rem; }
      .right-menu-item-link i:before {
        font-weight: bold;
        padding: 1px;
        background: -webkit-gradient(linear, left top, left bottom, color-stop(25%, #ad5beb), color-stop(50%, #c678db), color-stop(75%, #da6ea9), to(#e76e92));
        background: linear-gradient(180deg, #ad5beb 25%, #c678db 50%, #da6ea9 75%, #e76e92 100%);
        background-clip: text;
        text-fill-color: transparent;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent; }

    [class^="flaticon-"]:before, [class*=" flaticon-"]:before {
      font-family: Flaticon;
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      line-height: 1;
      text-decoration: inherit;
      text-rendering: optimizeLegibility;
      text-transform: none;
      -moz-osx-font-smoothing: grayscale;
      -webkit-font-smoothing: antialiased;
      font-smoothing: antialiased; }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MainToolbarChatComponent_tsickle_Closure_declarations() {
/** @type {?} */
MainToolbarChatComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MainToolbarChatComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
